import React from 'react';
import styled from 'styled-components';

const BetaLabelStyled = styled.div(({ theme }) => ({
  border: '1px solid',
  borderRadius: '20px',
  borderColor: theme.color.primary,
  color: theme.color.primary,

  display: 'flex',
  alignItems: 'center',
  fontSize: theme.font.size.xsmall,
  // fontWeight: 'bold',
  paddingLeft: '10px',
  paddingRight: '10px',
}));

const BetaLabel = () => {
  return <BetaLabelStyled>Beta Feature</BetaLabelStyled>;
};

export default BetaLabel;
